import React from "react";
import { FormattedMessage, injectIntl } from "gatsby-plugin-react-intl"
import { Button, Col, Container, Modal, Row } from "react-bootstrap"
import preferencesIcon from "../../images/preferences-icon.svg"

class NotificarePushManager extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      showBanner: false,
      showTagSelector: false,
      notificare: null,
      tag_products: true,
      tag_blog: true,
      tag_news: true
    }
  }

  componentDidMount(){
    let notificareScript = document.createElement('script');
    notificareScript.id = 'notificareJSLib';
    notificareScript.type = 'text/javascript';
    notificareScript.src = "https://cdn.notifica.re/libs/html5/v2/latest/notificare.min.js";

    if (!document.getElementById("notificareJSLib")) {
      document.body.appendChild(notificareScript);
      notificareScript.onload = () => {
        this.initNotificare();
      }
    } else {
      this.initNotificare();
    }
  }

  initNotificare = () => {

    let notificare = new window.Notificare({
      "appHost": "https://notificare.com",
      "appVersion": "2.0",
      "appKey": "b3076f1c7ebd24ff283888ffe317e72a92a8e85516bed29f4f8d3e6eb8a65f83",
      "appSecret": "cb3e338f219b251afeb10e80588a9095247e7b008cdd765e8dcdd17de4aabc9a",
      "soundsDir": "/sounds/",
      "serviceWorker": "/sw.js",
      "geolocationOptions": {
        "timeout": 60000,
        "enableHighAccuracy": true,
        "maximumAge": 100000
      }
    });

    this.setState({
      notificare: notificare
    });

    notificare.launch();

    notificare.didUpdateBadge = (badge) => {

    }

    notificare.didRegisterDevice = () => {

      if (notificare.isWebPushEnabled()) {
        notificare.addTag("tag_webpush_enabled");
        notificare.removeTag("tag_webpush_disabled");

        if (parseInt(window.localStorage.getItem('firstTimeUser'))) {
          this.setState({
            showTagSelector: true
          });
        }

        if (!window.localStorage.getItem('reminderTags')) {
          window.localStorage.setItem('reminderTags', Date.now());
        }


        notificare.fetchTags().then((tags) => {
          if (!tags.includes('tag_products')) {
            this.setState({
              tag_products: false
            });
          }

          if (!tags.includes('tag_blog')) {
            this.setState({
              tag_blog: false
            });
          }

          if (!tags.includes('tag_news')) {
            this.setState({
              tag_news: false
            });
          }
        });


        /*
        Disable this now because settings always accessible

        let shouldShow = false,
          lastTime = window.localStorage.getItem('reminderTags'),
          interval = (60 * 60 * 1000) * (24 * 30); // every 30 days

        if (!lastTime || (lastTime && parseInt(lastTime) < (Date.now() - interval))) {
          shouldShow = true;
        }

        if (shouldShow) {
          this.setState({
            showTagSelector: true
          });
        }*/

      } else {
        notificare.addTag("tag_webpush_disabled");
        notificare.removeTag("tag_webpush_enabled");
      }

    }

    notificare.didFailToRegisterDevice = (e) => {
      console.log('didFailToRegisterDevice', e);
    }

    notificare.didFailToRegisterForNotifications = (e) => {
      console.log('didFailToRegisterForNotifications', e);
    }

    notificare.didUpdateLocation = (location) => {
      console.log('didUpdateLocation', location);
    }

    notificare.didFailToUpdateLocation = (e) => {
      console.log('didFailToUpdateLocation', e);
    }

    notificare.didReceiveNotification = (notification) => {
      console.log('didReceiveNotification', notification);
    }


    notificare.didReceiveUnknownNotification = (notification) => {
      console.log('didReceiveUnknownNotification', notification);
    }


    notificare.didReceiveWorkerPush = (notification) => {
      console.log('didReceiveWorkerPush', notification);
    }


    notificare.didReceiveSystemNotification = (notification) => {
      console.log('didReceiveSystemNotification', notification);
    }

    notificare.didOpenNotification = (notification) => {
      notificare.presentNotification(notification); //Default UI for automatically handle all types of notifications
    }

    notificare.shouldPerformActionWithURL = (url) => {
      window.location.href = url;
    }


    notificare.onReady = () => {

      if (notificare.isWebPushEnabled()) {
        notificare.registerForNotifications();
      } else {
        let shouldShow = false,
          lastTime = window.localStorage.getItem('onboardingLastAttempt'),
          interval = (60 * 60 * 1000) * 24;

        if (!lastTime || (lastTime && parseInt(lastTime) < (Date.now() - interval))) {
          shouldShow = true;
        }

        if (shouldShow && !notificare.isWebPushDeniedByUser() && notificare.isWebPushSupported()) {
          this.setState({
            showBanner: true
          });
          this.addClassToBody();
        }

      }

    }

  }

  handleAccept = () => {
    window.localStorage.removeItem('onboardingLastAttempt');
    this.setState({
      showBanner: false
    });
    this.removeClassToBody();
    window.localStorage.setItem('firstTimeUser', 1);
    this.state.notificare.registerForNotifications();
  }

  handleDeny = () => {
    localStorage.setItem('onboardingLastAttempt', Date.now());
    this.setState({
      showBanner: false
    });
    this.removeClassToBody();
  }

  addClassToBody = () => {
    document.body.classList.add("has-notificare-banner");
  }

  removeClassToBody = () => {
    document.body.classList.remove("has-notificare-banner");
  }

  handleClose = () => {
    this.setState({
      showTagSelector: false
    });
    this.handleTags();
  }

  handleTags = () => {

    if (this.state.tag_products) {
      this.state.notificare.addTag("tag_products");
    } else {
      this.state.notificare.removeTag("tag_products");
    }

    if (this.state.tag_blog) {
      this.state.notificare.addTag("tag_blog");
    } else {
      this.state.notificare.removeTag("tag_blog");
    }

    if (this.state.tag_news) {
      this.state.notificare.addTag("tag_news");
    } else {
      this.state.notificare.removeTag("tag_news");
    }

    this.setState({
      showTagSelector: false
    });

    window.localStorage.setItem('firstTimeUser', 0);
    window.localStorage.setItem('reminderTags', Date.now());
  }


  render() {

    if (this.state.showBanner) {
      if (!this.props.scrollClass) {
        return (
          <div className={`notificare-push-banner`}>
            <Container>
              <div className={`bg`}></div>
              <div className={`wrapper`}>
                <div className={`title`}><FormattedMessage id="notificare.title" /></div>
                <div className={`text`}><FormattedMessage id="notificare.text" /></div>
                <div className={`buttons`}>
                  <Button className={`button`} variant={`outline-light`} onClick={this.handleAccept}><FormattedMessage id="notificare.accept" /></Button>
                  <Button className={`button deny`} variant={`transparent`} onClick={this.handleDeny}><FormattedMessage id="notificare.deny" /></Button>
                </div>
              </div>
            </Container>
          </div>
        )
      } else {
        return null;
      }
    } else {
      if (this.state.showTagSelector) {
        return (
          <Modal show={this.state.showTagSelector} centered={true} backdrop={`static`} dialogClassName={`tag-selector`} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title><FormattedMessage id="notificare.tagSelector.title" /></Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <p className={`text-center p-1`}><FormattedMessage id="notificare.tagSelector.text" /></p>

              <div className={`form-area`}>
                <Row>
                  <Col md={12}>
                    <div className={`form-field-group mt-3`}>
                      <label className="checkbox-container">
                        <span className={`title`}>{this.props.intl.formatMessage({id: "notificare.tagSelector.topics.products.title"})}</span>
                        {this.props.intl.formatMessage({id: "notificare.tagSelector.topics.products.text"})}
                        <input type={`checkbox`} checked={this.state.tag_products} name={`products`} onChange={(e) => {
                          this.setState({
                            tag_products: e.target.checked
                          });
                        }} />
                        <span className={`checkmark`}></span>
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className={`form-field-group mt-3`}>
                      <label className="checkbox-container">
                        <span className={`title`}>{this.props.intl.formatMessage({id: "notificare.tagSelector.topics.blog.title"})}</span>
                        {this.props.intl.formatMessage({id: "notificare.tagSelector.topics.blog.text"})}
                        <input type={`checkbox`} checked={this.state.tag_blog} name={`blog`} onChange={(e) => {
                          this.setState({
                            tag_blog: e.target.checked
                          });
                        }} />
                        <span className={`checkmark`}></span>
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className={`form-field-group mt-3`}>
                      <label className="checkbox-container">
                        <span className={`title`}>{this.props.intl.formatMessage({id: "notificare.tagSelector.topics.news.title"})}</span>
                        {this.props.intl.formatMessage({id: "notificare.tagSelector.topics.news.text"})}
                        <input type={`checkbox`} checked={this.state.tag_news} name={`news`} onChange={(e) => {
                          this.setState({
                            tag_news: e.target.checked
                          });
                        }} />
                        <span className={`checkmark`}></span>
                      </label>
                    </div>
                  </Col>
                </Row>
              </div>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={this.handleTags}><FormattedMessage id="notificare.tagSelector.button" /></Button>
            </Modal.Footer>
          </Modal>
        )
      } else {
        if (this.state && this.state.notificare && this.state.notificare.isWebPushEnabled()) {
          return (
            <button type={`button`} className={`push-settings`} onClick={() => {
              this.setState({
                showTagSelector: true
              });
            }}>
              <div className={`settings-icon`}>
                <img src={preferencesIcon} alt={``} />
              </div>
            </button>
          );
        } else {
          return null;
        }
      }
    }

  }
}

export default injectIntl(NotificarePushManager);
